import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, X, Smartphone } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export default function Cart() {
  const { cart, updateQty, removeFromCart, total } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  const shipping = total >= 999 || total === 0 ? 0 : 49;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="font-display font-semibold text-2xl mb-8">Your Cart</h1>
      {cart.length === 0 ? (
        <p className="text-white/40">Your cart is empty. <Link to="/" className="text-accent underline">Continue shopping</Link></p>
      ) : (
        <div className="grid md:grid-cols-3 gap-10">
          <div className="md:col-span-2 space-y-4">
            {cart.map((item) => (
              <div key={item._id} className="flex gap-4 items-center bg-surface border border-white/10 rounded-2xl p-4">
                <div className="w-16 h-16 rounded-lg bg-gradient-to-br from-slate-700 to-slate-900 flex items-center justify-center shrink-0">
                  {item.images?.[0] ? (
                    <img src={item.images[0]} alt={item.name} className="w-full h-full object-cover rounded-lg" />
                  ) : (
                    <Smartphone size={24} className="text-white/70" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium truncate">{item.name}</div>
                  <div className="font-mono text-sm text-mint">₹{item.price.toFixed(2)}</div>
                </div>
                <div className="flex items-center gap-2 bg-white/5 rounded-full px-2 py-1">
                  <button onClick={() => updateQty(item._id, item.qty - 1)}><Minus size={12} /></button>
                  <span className="text-xs font-mono w-4 text-center">{item.qty}</span>
                  <button onClick={() => updateQty(item._id, item.qty + 1)}><Plus size={12} /></button>
                </div>
                <button onClick={() => removeFromCart(item._id)} className="text-white/40 hover:text-red-400">
                  <X size={16} />
                </button>
              </div>
            ))}
          </div>
          <div className="bg-surface border border-white/10 rounded-2xl p-6 h-fit">
            <div className="flex justify-between text-sm mb-2 font-mono">
              <span className="text-white/50">Subtotal</span><span>₹{total.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-sm mb-4 font-mono">
              <span className="text-white/50">Shipping</span><span>{shipping === 0 ? "Free" : `₹${shipping.toFixed(2)}`}</span>
            </div>
            <div className="flex justify-between font-semibold text-lg mb-6 font-mono border-t border-white/10 pt-4">
              <span>Total</span><span>₹{(total + shipping).toFixed(2)}</span>
            </div>
            <button
              onClick={() => navigate(user ? "/checkout" : "/login")}
              className="w-full bg-accent hover:bg-orange-500 text-black font-semibold rounded-full py-3 text-sm transition"
            >
              Checkout
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
